import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;
Vue.component("modal", {
  template: "#modal-template"
});
new Vue({
  render: h => h(App)
}).$mount("#app");
